import AdminController from './admin_controller';

export default class extends AdminController { }
